angular.module("avant.customer_applications.controllers").controller "CustomerApplicationsReturnToMerchantCtrl", [
  "$controller"
  "$scope"
  "ApplicationService"
  "CustomerApplicationService"
  (
    $controller
    $scope
    ApplicationService
    CustomerApplicationService
  ) ->

    $scope.page = "return_to_merchant"
    $scope.stageFromState = () => $scope.page

    $scope.$emit("customer_application:data", ApplicationService.data)
    angular.extend(
      $scope,
      $controller(
        "CustomerApplicationsMixinCtrl"
        {
          $scope: $scope
          ApplicationService
          CustomerApplicationService
        }
      )
    )

    $scope.trackVisit()
]
